"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsUserUnsubscription {
    static getAttributeTypeMap() {
        return GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsUserUnsubscription.attributeTypeMap;
    }
}
GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsUserUnsubscription.discriminator = undefined;
GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsUserUnsubscription.attributeTypeMap = [
    {
        "name": "campaignId",
        "baseName": "campaignId",
        "type": "number"
    },
    {
        "name": "eventTime",
        "baseName": "eventTime",
        "type": "string"
    },
    {
        "name": "ip",
        "baseName": "ip",
        "type": "string"
    }
];
exports.GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsUserUnsubscription = GetExtendedContactDetailsAllOfStatisticsUnsubscriptionsUserUnsubscription;
//# sourceMappingURL=getExtendedContactDetailsAllOfStatisticsUnsubscriptionsUserUnsubscription.js.map